angular.module('cian.metroBrowser').directive('metroLine', ['$sce', function($sce) {
  return {
    scope: {},
    template: require('../../templates/metro-svg-browser.line.html'),
    templateNamespace: 'svg',
    restrict: 'A',
    link($scope, $element, attrs) {

    },
    bindToController: {
      lineData: '<',
      metroState: '='
    },
    controller: [function() {
      this.getTranslate = (obj) => `translate(${obj.x} ${obj.y})`;

      this.trust = (...args) => $sce.trustAsHtml.apply(this, args);

      this.handleClick = (e) => {
        var allActive = this.lineData.ids.every((stationId) => {
          return this.metroState.stations[stationId].isActive === true;
        });

        this.lineData.ids.forEach((stationId) => {
          this.metroState.stations[stationId].isActive = allActive ? false : true;
        });
      };

      this.handleMouseEnter = (e, segmentId) => {
        this.metroState.lines[this.lineData.id].isHover = true;
        this.lineData.ids.forEach((stationId) => {
          this.metroState.stations[stationId].isHover = true;
        });
      };

      this.handleMouseLeave = (e, segmentId) => {
        this.metroState.lines[this.lineData.id].isHover = false;
        this.lineData.ids.forEach((stationId) => {
          this.metroState.stations[stationId].isHover = false;
        });
      };

      this.handleSegmentClick = (e, segmentId) => {
        const segment = this.lineData.segments.find(item => item.id === segmentId);

        var allActive = segment.ids.every((stationId) => {
          return this.metroState.stations[stationId].isActive === true;
        });

        segment.ids.forEach((stationId) => {
          this.metroState.stations[stationId].isActive = allActive ? false : true;
        });
      };

      this.handleSegmentMouseEnter = (e, segmentId) => {
        const segment = this.lineData.segments.find(item => item.id === segmentId);
        this.metroState.segments[segmentId].isHover = true;
        angular.isObject(segment) && segment.ids.forEach((stationId) => {
          this.metroState.stations[stationId].isHover = true;
        });
      };

      this.handleSegmentMouseLeave = (e, segmentId) => {
        const segment = this.lineData.segments.find(item => item.id === segmentId);
        this.metroState.segments[segmentId].isHover = false;
        angular.isObject(segment) && segment.ids.forEach((stationId) => {
          this.metroState.stations[stationId].isHover = false;
        });
      };
    }],
    controllerAs: 'lineCtrl'
  };
}]);



// WEBPACK FOOTER //
// ./src/components/metro-browser/src/scripts/cian.metro-svg-browser.line.dir.js